<ui-select-mini
  [list]="langList"
  [value]="selectedLang"
  (valueChange)="onSelectedLangChanged($event)"
  displayField="description"
  valueField="id"
  width="71px"
></ui-select-mini>
